module.exports = __webpack_public_path__ + "img/andreea-welcome.081533f2.png";